import { render, staticRenderFns } from "./CreatePostButtonController.vue?vue&type=template&id=7d179ac8&"
import script from "./CreatePostButtonController.vue?vue&type=script&lang=ts&"
export * from "./CreatePostButtonController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports